module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/node_modules/core-js/modules/_library.js
// module id = 1793
// module chunks = 6 7 17 18